import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import AnimeCard from "@/components/base/AnimeCard";
import { animeList } from "@/mocks/anime";

const tabs = [
  { key: "hot", label: "热门排行" },
  { key: "new", label: "新番上线" },
  { key: "all", label: "全部动漫" },
];

export default function AnimeShowcase() {
  const [active, setActive] = useState("hot");

  const list = useMemo(() => {
    if (active === "new") return animeList.filter((a) => a.year === "2026");
    if (active === "all") return animeList;
    return [...animeList].sort((a, b) => b.rating - a.rating).slice(0, 8);
  }, [active]);

  const showList = active === "all" ? animeList : list.slice(0, 8);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="font-heading text-sm text-primary-600">动漫网动画库</span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">全部动漫列表</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              热门排行、新番上线与全部动漫一键切换，快速锁定想看的作品。
            </p>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-2 rounded-full border border-background-200/70 bg-background-50 p-1 w-fit">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActive(tab.key)}
              className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium transition-colors ${
                active === tab.key ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {showList.map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/categories"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-7 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            浏览全部动漫
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}